import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { CEOFeature } from "@/components/site/CEOFeature";
import { Accelerator } from "@/components/site/Accelerator";
import { Experience } from "@/components/site/Experience";
import { Media } from "@/components/site/Media";
import { Mentors } from "@/components/site/Mentors";
import { Impact } from "@/components/site/Impact";
import { Partnership } from "@/components/site/Partnership";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ApplyModal } from "@/components/site/ApplyModal";
import { PartnerModal } from "@/components/site/PartnerModal";
import { WatchModal } from "@/components/site/WatchModal";
import { JadeChat } from "@/components/site/JadeChat";

export default function Home() {
    const [apply, setApply] = useState(false);
    const [partner, setPartner] = useState(null); // null | "partner" | "sponsor"
    const [watch, setWatch] = useState(false);

    return (
        <div className="relative">
            <Navbar onApply={() => setApply(true)} />
            <Hero
                onApply={() => setApply(true)}
                onPartner={() => setPartner("partner")}
                onWatch={() => setWatch(true)}
            />
            <About />
            <Accelerator />
            <Experience onWatch={() => setWatch(true)} />
            <Media />
            <Mentors />
            <CEOFeature />
            <Impact />
            <Partnership onPartner={(mode) => setPartner(mode || "partner")} />
            <Gallery />
            <Testimonials />
            <Contact />
            <Footer />

            <ApplyModal open={apply} onClose={() => setApply(false)} />
            <PartnerModal
                open={!!partner}
                mode={partner ?? "partner"}
                onClose={() => setPartner(null)}
            />
            <WatchModal open={watch} onClose={() => setWatch(false)} />

            <JadeChat
                onApply={() => setApply(true)}
                onPartner={(mode) => setPartner(mode || "partner")}
            />
        </div>
    );
}
